import { t, Trans } from '@lingui/macro'
import {
  Button,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'
import { useRouterContext } from '@speedlo/hooks'
import React, { ChangeEvent, useCallback, useState } from 'react'
import styled from 'react-emotion'
import { IAccount } from 'shopify-payment-core'

import { useFirebaseFunctions } from '../hooks/useFirebaseFunctions'
import { i18n } from '../i18n'

interface IProps extends ButtonProps {
  account: IAccount
}

const RedButton = styled(Button)`
  color: ${colors.red[400]};
`

const NoSelect = styled(Typography)`
  user-select: none;
`

export const AccountDeleteButton: React.FC<IProps> = ({ account }) => {
  const [isOpen, setOpen] = useState(false)
  const { history } = useRouterContext()

  const { deleteAccount } = useFirebaseFunctions()
  const onConfirm = useCallback(async () => {
    await deleteAccount({
      accountId: account.id,
      segmentKey: account.segmentKey,
    })
    history.replace('/')
  }, [])

  const onFieldChange = useCallback((ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value
    if (value.toLocaleLowerCase() === account.shopName.toLocaleLowerCase()) {
      setOpen(false)
      onConfirm()
    }
  }, [])

  return (
    <>
      <Tooltip title={i18n._(t`Smazání účtu vyžaduje potvrzení`)}>
        <RedButton
          variant="outlined"
          onClick={() => setOpen(true)}
          disabled={isOpen}
        >
          <Trans>Smazat účet?</Trans>
        </RedButton>
      </Tooltip>
      <Dialog open={isOpen}>
        <DialogTitle>
          <Trans>Smazání účtu</Trans>
        </DialogTitle>
        <DialogContent>
          <NoSelect>
            <Trans>
              Odstraněním účtu obchodu dojde ke smazání všech souvejících dat
              včetně plateb. Tyto data nelze později obnovit. Pro potvrzení
              smazání opiš název obchodu <b>{account.shopName}</b> do vstupního
              pole.
            </Trans>
          </NoSelect>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            <Trans>Zrušit</Trans>
          </Button>
          <TextField autoFocus={true} onChange={onFieldChange} />
        </DialogActions>
      </Dialog>
    </>
  )
}
